import React from "react";
import Switch from "@material-ui/core/Switch";

export const FeatureItem = ({ item, update }) => {
  return (
    <tr>
      <td>
        <div className="py-4 d-flex align-items-center">{item.name}</div>
      </td>
      <td>
        <Switch
          checked={item.is_active}
          onChange={e => {
            const { target } = e;

            update({ ...item, is_active: target.checked });
          }}
          name={item.name}
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      </td>
    </tr>
  );
};
